<div
  class="grid grid-flow-row-dense grid-cols-3 gap-4"
  cdkDropList
  cdkDropListOrientation="mixed"
  (cdkDropListDropped)="drop($event)">
  @for (item of items; track item) {
    <p-card
      [style]="{ overflow: 'hidden' }"
      (cdkDropListDropped)="drop($event)"
      cdkDrag>
      <ng-template #header>
        <div class="relative">
          <img
            class="w-full"
            [src]="'/assets/images/storyshots/' + item + '-1.png'"
            alt="alt"
            draggable="false" />
          <div class="absolute top-0 right-0 p-1">
            <p-buttongroup>
              <p-button severity="secondary" icon="fa fa-info-circle" />
              <p-button severity="secondary" icon="fa fa-upload" />
            </p-buttongroup>
          </div>
        </div>
      </ng-template>
      <ng-template #title>
        <h5>Scene 1 | Shot {{ item }}</h5>
      </ng-template>
      <p>
        Some quick example text to build on the card title and make up the bulk
        of the card's content.
      </p>
      <ng-template #footer>
        <p-buttongroup>
          <p-button class="grow" styleClass="w-full" label="Edit" />
          <p-button class="grow" styleClass="w-full" label="Variations" />
          <p-button class="grow" styleClass="w-full" label="Refresh" />
        </p-buttongroup>
      </ng-template>
    </p-card>
  }
</div>
